// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wiki-header-label[data-v-68ba4782]{font-weight:bolder;font-size:22px}@media (max-width: 767px){.wiki-header-label[data-v-68ba4782]{font-size:19px}}@media (min-width: 768px){.wiki-header-label[data-v-68ba4782]{font-size:21px;line-height:58px}}\n", ""]);
// Exports
module.exports = exports;
